import {
  clusterApiUrl,
  Connection,
  LAMPORTS_PER_SOL,
  PublicKey,
} from "@solana/web3.js";

////////////////
// Constants //
///////////////

export const TOKEN_A_DECIMALS = 1_000_000;

export const TOKEN_B_DECIMALS = LAMPORTS_PER_SOL;

export const TOKEN_SWAP_PROGRAM_ID = new PublicKey(
  "9L68fWPJQRdsyeSbLUy4nVjPkj9fLK9vuVhs6h91tqyN"
);

export const rpc =
  "https://devnet.helius-rpc.com/?api-key=976801c8-1237-4e44-94e3-3f03f9a1212d";

export const connection = new Connection(clusterApiUrl("devnet"), "confirmed");

/////////////////////////
// Replaceable Values //
////////////////////////

// Burn Wallet
export const fee_owner = new PublicKey(
  "AhaqZkm3CBJW8Fr2jxjWXa1bmueTyUaBF9GpRrWPzHdt"
);

// LFC Token Address Need to replace
export const LFC_PAIR = new PublicKey(
  // "8K88szwNHoALxCozK2z4cnheKfoQdpFSHYz2SdL7r6uP"
  "BnrtyeS3YGfkTTU7LtkEeUr5u4qB29FLDE4ro7Y4nVV8"
);

// token swap state account Address Need to replace
export const tokenSwap = new PublicKey(
  "4jWPzvPmT64gh6uVcWUfhCRv3PvDycNHA3sUWes4qejw"
);

// Need to replace
export const swapAuthority = new PublicKey(
  "DJgXuRxierJ4r2bHgYkUHpop75eLVX61gtEgxjZr5YxK"
);

// Need to replace
export const LP_TOKEN = new PublicKey(
  "EwwWYgwyz7i8dP8F7BCRXVBSgc7bDEqargBYTgU1R7W"
);

//////////////////////////////////////////////////////////////////////////////////////////
////  Token Buy Contract Values  ////
//////////////////////////////////////////////////////////////////////////////////////////

//  Generates on every new Token  Initialization and needs to be replaced
export const token_sale_config = new PublicKey(
  "5V3srcmnihcENfpjSGeKoNHxnBxpWcmG3zx8KpjzcRZg"
);

// The token Authority that can pause/resume sale
export const token_authority = new PublicKey(
  "AFPbUHT9DTq79mDQJEnQNSi8tHPBZkxgVwzyXrwDpBpz"
);

// The address of the (LAL) token
export const token_mint = new PublicKey(
  "7G7i5AqcSrn7E8vyj6FKepdvLzG74TW7vNSk5NT7FT3o"
);

// The address of the account, that will recieve the SOL form Buy
export const token_recipent_account = new PublicKey(
  "2yFWQA8kZjjWeKBTf8gAteKCfDFcmPej6J2UmRPUTecV"
);

// This is the sale_authority to which tokens will be sent, within the program
// that will be responsible for sending tokens to the buyer
export const sale_authority = new PublicKey(
  "AZQhTvzARZ5A2UtZJ82h4LiKJmnumtTmD2RP5cvmMMCP"
);
